<div class="template-info-blurb">
  <ng-content></ng-content>
</div>
